import { defaultTemplate } from "../models/defaultTemplate";
import {
  getValueFromNestedObject,
  getValueFromNestedObjectByParam,
} from "../../../../helpers/objectHelper";

export const templateHelper = {
  checkForUpdates,
  handleElementUpdates,
  formatToResponsivePath,
  getUnit,
  getValueFromInput,
  getValue,
  getValueWithoutUnit,
  assignResponsiveStyle,
  parseColorToRgba,
  getTemplatesColors,
  parseRgbaToHex,
  convertRgbStringToHex,
  backgroundApplier,
  getInteractionStyles,
};

function getInteractionStyles(path, template) {
  if (!template) return {};
  if (path == "exhibitors") {
    if (template.interaction.exhibitor) {
      const obj = template.interaction.exhibitor;

      if (obj) {
        const container = obj.frame;
        const title = obj.title;
        const subtitle = obj.subtitle;
        const logo = obj.logo;

        /* 
                       primaryColor: primaryColor != 'unset' ? primaryColor : '#5a60e3', */

        return {
          frame: {
            background:
              container && container.background != "unset"
                ? container.background
                : "rgba(31, 30, 30, 0.4)",
            borderRadius:
              container && container.borderRadius != "unset"
                ? container.borderRadius
                : "4px",
            padding:
              container && container.padding != "unset"
                ? container.padding
                : "0px",
          },
          title: {
            color: title && title.color != "unset" ? title.color : "#fff",
            fontSize:
              title && title.fontSize != "unset"
                ? title.fontSize
                : template.subtitle.fontSize,
            fontWeight:
              title && title.fontWeight != "unset"
                ? title.fontWeight
                : template.subtitle.fontWeight,
            fontFamily:
              title && title.fontFamily != "unset"
                ? title.fontFamily
                : template.subtitle.fontFamily,
          },
          logo: {
            background:
              logo && logo.background != "unset" ? logo.background : "#fff",
          },
          subtitle: {
            color:
              subtitle && subtitle.color != "unset" ? subtitle.color : "#fff",
            fontSize:
              subtitle && subtitle.fontSize != "unset"
                ? subtitle.fontSize
                : template.text.fontSize,
            fontWeight:
              subtitle && subtitle.fontWeight != "unset"
                ? subtitle.fontWeight
                : template.text.fontWeight,
            fontFamily:
              subtitle && subtitle.fontFamily != "unset"
                ? subtitle.fontFamily
                : template.text.fontFamily,
          },
        };
      } else {
        return {
          frame: {
            background: "rgba(31, 30, 30, 0.4)",
            borderRadius: "4px",
            padding: "0px",
          },
          logo: { background: "#fff" },
          title: template.subtitle,
          subtitle: template.text,
        };
      }
    } else {
      return {
        frame: {
          background: "rgba(31, 30, 30, 0.4)",
          borderRadius: "4px",
          padding: "0px",
        },
        logo: { background: "#fff" },
        title: template.subtitle,
        subtitle: template.text,
      };
    }
  }
  if (path == "connections") {
    if (template.interaction.connections) {
      return {
        content: {
          background: template.interaction.connections.background,
          borderRadius: template.interaction.connections.borderRadius,
          borderWidth: template.interaction.connections.borderWidth,
          borderColor: template.interaction.connections.borderColor,
          borderStyle:
            template.interaction.connections.borderWidth != "unset"
              ? "solid"
              : undefined,
        },
        text: {
          fontSize: template.interaction.connections.fontSize,
          fontWeight: template.interaction.connections.fontWeight,
          fontFamily:
            template.interaction.connections.fontFamily + " !important",
          color: template.interaction.connections.color,
        },
      };
    } else {
      return {
        content: {
          background: template.content
            ? template.content.backgroundColor
            : "#fff",
        },
        text: {
          ...template.label,
        },
      };
    }
  }
  return {};
}

function parseColorToRgba(color) {
  const { r, g, b, a } = color.rgb;
  return `rgba(${r},${g},${b},${a})`;
}

function parseRgbaToHex(color) {
  const { r, g, b, a } = color.rgb;
  var red = hexCode(r);
  var green = hexCode(g);
  var blue = hexCode(b);

  return "#" + red + green + blue;
}

function convertRgbStringToHex(rgb, param = null) {
  if (rgb == "white") return "#ffffff";
  if (rgb == "black") return "#000000";

  if (!rgb.toString().includes("rgb")) return rgb;
  var a = rgb.split("(")[1].split(")")[0];
  a = a.split(",");
  let hex = "#";
  for (let index = 0; index < a.length; index++) {
    let x = parseInt(a[index]).toString(16); //Convert to a base16 string
    hex += x.length == 1 ? "0" + x : x;
  }
  if (hex.length > 7) hex = hex.substring(0, 7);
  return hex;
}

function hexCode(rgb) {
  var hex = Number(rgb).toString(16);
  if (hex.length < 2) {
    hex = "0" + hex;
  }
  return hex;
}
function getValueFromInput(e, color) {
  if (e === null) return "unset";

  if (parseInt(e) || (typeof e === "string" && e.length > 0)) return e;
  else if (color) return parseColorToRgba(color);
  else if (e.target && e.target.value) return e.target.value;
}

function assignResponsiveStyle(source) {
  const responsiveNames = ["content", "header", "footer", "menu"];
  const devices = ["tablet", "smartphone"];
  const newStyle = Object.assign({}, source);
  for (let x = 0; x < responsiveNames.length; x++) {
    for (let y = 0; y < devices.length; y++) {
      const defaultStyle =
        defaultTemplate.responsive[devices[y]][responsiveNames[x]];
      const mainStyle = defaultTemplate[responsiveNames[x]];
      for (const key in newStyle.responsive[devices[y]][responsiveNames[x]]) {
        if (
          defaultStyle[key] !== "unset" &&
          newStyle.responsive[devices[y]][responsiveNames[x]][key] === "unset"
        ) {
          newStyle.responsive[devices[y]][responsiveNames[x]][key] =
            defaultStyle[key];
        } else if (
          defaultStyle[key] === "unset" &&
          newStyle.responsive[devices[y]][responsiveNames[x]][key] === "unset"
        ) {
          newStyle.responsive[devices[y]][responsiveNames[x]][key] =
            mainStyle[key];
        }
      }
    }
  }
  return newStyle;
}

function getTemplatesColors(template) {
  const colors = [];
  getValueFromNestedObjectByParam(
    ["color", "backgroundColor"],
    template.content,
    colors
  );
  return colors;
}

function getUnit(template, names) {
  let value = undefined;
  let unit = "";
  if (!Array.isArray(names)) names = names.split(".");
  if (names.includes("boxShadow")) return unit;
  value = getValueFromNestedObject(names, template.content, value);
  if (value !== undefined) {
    if (value === "unset") unit = "px";
    else if (parseInt(value)) unit = value.replace(/[0-9/^d.-]/g, "");
    else unit = "px";
  }
  return unit;
}

function backgroundApplier(value, path, onChange) {
  onChange(value, path);
}

function getValue(template, names) {
  let value = "";
  if (!Array.isArray(names)) names = names.split(".");
  value = getValueFromNestedObject(names, template.content, value);
  return value;
}
function getValueWithoutUnit(template, names) {
  let value = 0;
  if (!Array.isArray(names)) names = names.split(".");
  value = getValueFromNestedObject(names, template.content, value);
  try {
    if (value.includes("rgb") || value.includes("#") || value.includes("white"))
      return value;
    else if (value === "unset") value = 0;
    if (value === "unset") value = 0;
    else value = value.replace(/[^0-9\d.-]/g, "");
    value = parseInt(value);
  } catch (error) {}
  return value;
}

function formatToResponsivePath(parent, prop, device) {
  if (device === "desktop") return `${parent}.${prop}`;
  return `responsive.${device}.${parent}.${prop}`;
}

/*DEPRECATED*/
function checkForUpdates(target, source) {
  const sourceObj = Object.assign({}, source);
  let targetObj = Object.assign({}, target);

  //* Loops two levels of an object*/
  for (const prop in sourceObj) {
    if (!targetObj.hasOwnProperty(`${prop}`)) {
      targetObj[prop] = { ...sourceObj[prop] };
      if (targetObj.hasOwnProperty(`${prop}`)) {
      }
    } else {
      for (const v in sourceObj[prop]) {
        if (!targetObj[prop].hasOwnProperty(v)) {
          targetObj[prop][v] = sourceObj[prop][v];
          if (targetObj[prop].hasOwnProperty(`${v}`)) {
          }
        }
      }
    }
  }
}

function handleElementUpdates(element, template) {
  //Move this code to reducer
  if (element.parentName === "HEADER") {
    let el = template.content.header.content.find((f) => {
      return f.contentId === element.contentId;
    });
    var indexOfRemovedEl = template.content.header.content.indexOf(el);
    if (indexOfRemovedEl > -1) {
      template.content.header.content.splice(indexOfRemovedEl, 1);
      template.content.header.content.push(element);
    }
  }
  if (element.parentName === "FOOTER") {
    let el = template.content.footer.content.find((f) => {
      return f.contentId === element.contentId;
    });
    var indexOfRemovedEl = template.content.footer.content.indexOf(el);
    if (indexOfRemovedEl > -1) {
      template.content.footer.content.splice(indexOfRemovedEl, 1);
      template.content.footer.content.push(element);
    }
  }
  return template;
}
